import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'

import './History.scss'

@observer
class History extends Component {
  state = {
    acitveFilter: 0,
    filteredList: [],
    openId: null,
  }

  sortByFrom(arr) {
    arr.sort((a, b) => a.From > b.From ? 1 : -1);
  }

  sortByTo(arr) {
    arr.sort((a, b) => a.To > b.To ? 1 : -1);
  }

  chgFilter = id => {
    let filteredList  = [...this.props.historyList]
    if(id === 1){
      this.sortByFrom(filteredList)
    } else if (id === 2){
      this.sortByTo(filteredList)
    } else {
      filteredList = []
    }
    this.setState({
      acitveFilter: id,
      filteredList
    })
  }

  openInfo = id => {
    this.setState({
      openId: id,
    })
  }

  componentDidMount(){
    this.props.getHistory()
  }

  render() {
    const listToShow = this.state.filteredList.length > 0 ? [...this.state.filteredList] : [...this.props.historyList]

    const history = listToShow.map( item => {
      let carClass = ''
      if(item.clasAvto === 2){
        carClass = 'Стандарт'
      } else if (item.clasAvto === 2){
        carClass = 'Бизнес'
      } else if (item.clasAvto === 2){
        carClass = 'Премиум'
      } else if (item.clasAvto === 2){
        carClass = 'Без класса'
      }

      const fullInfo = item.id === this.state.openId ? 
      (
        <div className="history-info-full">
          <div>{item.Car}</div>
          <div>{carClass}</div>          
          <div className="history-dp">
            <div className="history-distance">{item.distance} км.</div>
            <div className="history-price"><span>{item.Price}</span> грн.</div>  
          </div>
        </div>
      ) : null
      return (<div className="col history-item">
        <div className="col-12 history-date">
          {item.When}
        </div>
        <ul>
          <li className="history-from">{item.From}</li>
          <li className="history-to">{item.To}</li>
        </ul>
        {fullInfo}
        <button 
          className={item.id === this.state.openId ? "arrow open" : "arrow"}
          onClick={ () => item.id === this.state.openId ? this.openInfo(null) : this.openInfo(item.id)}
        ></button>
      </div>)
    })

    return (<>
      <div className="col history-filters">
        <ul className="">
          <li className={this.state.acitveFilter === 0 ? "active" : null} onClick={ () => this.chgFilter(0)}>Дата</li>
          <li className={this.state.acitveFilter === 1 ? "active from" : "from"} onClick={ () => this.chgFilter(1)}>Откуда</li>
          <li className={this.state.acitveFilter === 2 ? "active filterTo" : "filterTo"} onClick={ () => this.chgFilter(2)}>Куда</li>
        </ul>
      </div>
      {history}
      </>
    )
  }
}

const withData = inject(stores => ({
  historyList: stores.HistoryStore.historyList,
  getHistory: stores.HistoryStore.getHistory,
}))

export default withData(History);
